import {createApp} from 'vue'
import Store from 'store'
import SelectedBulkOverview from './SelectedBulkOverview'

const component = createApp(SelectedBulkOverview).use(Store)

const el = '.nlx-component--selected-bulk-overview'
const DOM = document.querySelector(el)

if(DOM){
    component.mount(el)
}

